import React from "react";
import { STEPS } from "../constants";
import { StepChip, StepsRow } from "../AddLanguageWizard.styled";

const WizardSteps = ({ step }) => (
  <StepsRow>
    {STEPS.map((item) => (
      <StepChip
        key={item.number}
        $active={step === item.number}
        $done={step > item.number}
      >
        {item.number}. {item.label}
      </StepChip>
    ))}
  </StepsRow>
);

export default WizardSteps;
